import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Popup, DatetimePicker, Picker } from 'vant'
import 'vant/lib/index.css'
import './utils/flexible'
import './assets/styles/index.scss'

Vue.use(Popup)
Vue.use(DatetimePicker)
Vue.use(Picker)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
